<span class="example">
  E-Mail versendet
</span>
